import { Link } from "react-router-dom";
import { useState } from "react";
import { LOGO_URL } from "@/constants/network";
import { NAV } from "@/constants/testIds";
import { Menu, X, Rocket } from "lucide-react";
import { DesktopNav, MobileNav } from "@/components/layout/header/NavLinks";
import { WalletMenu } from "@/components/layout/header/WalletMenu";

const Logo = () => (
  <Link to="/" className="group flex items-center gap-2.5 shrink-0" data-testid={NAV.logo}>
    <span className="coin-logo w-8 h-8">
      <img src={LOGO_URL} alt="FSC" className="w-8 h-8 rounded-full" />
    </span>
    <span className="font-display font-bold text-lg tracking-tight text-white hidden sm:block">
      FSC<span className="text-[#D4AF37] ml-0.5">Hub</span>
    </span>
  </Link>
);

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2 shrink-0">
            <Logo />
            <span data-testid="header-network-badge" className="hidden sm:inline-flex text-[10px] font-medium text-[#D4AF37] border border-[#D4AF37]/40 bg-[#D4AF37]/10 rounded-full px-2 py-0.5 whitespace-nowrap">
              FSC Live Beta (Chain 77177)
            </span>
          </div>
          <DesktopNav />
          <div className="flex items-center gap-3">
            <Link to="/get-started" data-testid={NAV.getStartedLink} title="Get started"
              className="hidden lg:inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-[#D4AF37] hover:text-[#F3E5AB] transition-colors">
              <Rocket size={14} /> <span className="sr-only">Get started</span>
            </Link>
            <WalletMenu />
            <button data-testid={NAV.mobileMenuBtn} className="md:hidden p-2 text-zinc-400 hover:text-white" onClick={() => setMobileOpen((o) => !o)}>
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
        {mobileOpen && <MobileNav onClose={() => setMobileOpen(false)} />}
      </div>
    </header>
  );
}
